import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MfaSessionService {
  private otpOutstanding = false;

  markOtpOutstanding() {
    this.otpOutstanding = true;
  }

  clearOtpOutstanding() {
    this.otpOutstanding = false;
  }

  isOtpOutstanding(): boolean {
    return this.otpOutstanding;
  }
}
